import Link from "next/link";
import { Heading, Stack, Text } from "@chakra-ui/react";
import { HEADING_VARIANTS } from "@/theme/components/heading";
import { FOOTER_CONSTANTS, SERVICE_OPTIONS } from "../footer.constants";

const FooterService = () => {
  return (
    <Stack spacing={6} color="white">
      <Heading variant={HEADING_VARIANTS.SUBTITLE2}>{FOOTER_CONSTANTS.SERVICES}</Heading>
      <Stack>
        {SERVICE_OPTIONS.map((option) => {
          const { name, path } = option;
          return (
            <Link href={path} key={path}>
              <Text _hover={{ textDecor: "underline" }}>{name}</Text>
            </Link>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default FooterService;
